import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { PwaInstallService } from '../../../core/pwa/pwa-install.service';
import { TranslatePipe } from '../../../core/i18n/translate.pipe';
import { IconComponent } from '../icon/icon.component';

@Component({
  selector: 'lem-pwa-install-prompt',
  standalone: true,
  imports: [CommonModule, IconComponent, TranslatePipe],
  templateUrl: './pwa-install-prompt.component.html',
  styleUrl: './pwa-install-prompt.component.scss',
})
export class PwaInstallPromptComponent {
  readonly pwa = inject(PwaInstallService);
  readonly installing = signal(false);
  readonly showIosHelp = signal(false);
  readonly isMobile = computed(() => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches);

  async install(): Promise<void> {
    if (this.pwa.mode() === 'ios') {
      this.showIosHelp.set(true);
      return;
    }

    this.installing.set(true);
    try {
      await this.pwa.install();
    } finally {
      this.installing.set(false);
    }
  }

  close(): void {
    this.showIosHelp.set(false);
    this.pwa.close();
  }
}
